// Vendor libraries
import { EventEmitter } from '@angular/core';
// Components
import { BaseAutocompleteComponent } from 'SearchApp/ts/features/base-autocomplete/components/base-autocomplete.component';
import * as i0 from "@angular/core";
import * as i1 from "../base-autocomplete/components/base-autocomplete.component";
/**
 *
 * Icon Search Autocomplete Component
 *
 * Output Properties:
 *   submitHandler: EventEmitter that emits the selected AutocompleteResult
 *
 */
export class IconSearchAutocompleteComponent {
    constructor() {
        this.placeholder = 'Search';
        this.defaultOnly = false;
        this.submitHandler = new EventEmitter();
    }
    focus() {
        if (this.baseAutocompleter) {
            this.baseAutocompleter.focus();
        }
    }
    reset() {
        if (this.baseAutocompleter) {
            this.baseAutocompleter.reset();
        }
    }
}
IconSearchAutocompleteComponent.ɵfac = function IconSearchAutocompleteComponent_Factory(t) { return new (t || IconSearchAutocompleteComponent)(); };
IconSearchAutocompleteComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: IconSearchAutocompleteComponent, selectors: [["ycn-icon-search-autocomplete"]], viewQuery: function IconSearchAutocompleteComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(BaseAutocompleteComponent, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.baseAutocompleter = _t.first);
    } }, inputs: { appendToBody: "appendToBody", placeholder: "placeholder", searchType: "searchType", defaultOnly: "defaultOnly" }, outputs: { submitHandler: "submitHandler" }, decls: 1, vars: 5, consts: [[1, "input-group", "field-input-group", 3, "submitHandler", "appendToBody", "buttonType", "placeholder", "searchType", "defaultOnly"]], template: function IconSearchAutocompleteComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "ycn-base-autocomplete", 0);
        i0.ɵɵlistener("submitHandler", function IconSearchAutocompleteComponent_Template_ycn_base_autocomplete_submitHandler_0_listener($event) { return ctx.submitHandler.emit($event); });
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("appendToBody", ctx.appendToBody)("buttonType", "icon-search")("placeholder", ctx.placeholder)("searchType", ctx.searchType)("defaultOnly", ctx.defaultOnly);
    } }, dependencies: [i1.BaseAutocompleteComponent], encapsulation: 2 });
